
export const contactTranslations = {
  en: {
    contact: {
      title: "Contact Us",
      getInTouch: "Get in Touch",
      description: "Have questions or feedback? We'd love to hear from you. Use the form below or reach out directly.",
      email: "Email",
      linkedin: "LinkedIn",
      officeHours: "Office Hours",
      hours: "Monday to Friday: 9am - 5pm (EST)",
      sendMessage: "Send Us a Message",
      successMessage: "Thank you! Your message has been sent successfully.",
      errorMessage: "There was an error sending your message. Please try again later.",
      form: {
        email: "Your Email",
        subject: "Subject",
        message: "Message",
        send: "Send Message",
        sending: "Sending..."
      },
      location: "Our Location",
      address: "C. Navío, 3, 11540 Sanlúcar de Barrameda, Cádiz, Spain"
    }
  },
  es: {
    contact: {
      title: "Contáctanos",
      getInTouch: "Ponte en Contacto",
      description: "¿Tienes preguntas o comentarios? Nos encantaría escucharte. Utiliza el formulario a continuación o contáctanos directamente.",
      email: "Correo Electrónico",
      linkedin: "LinkedIn",
      officeHours: "Horario de Oficina",
      hours: "Lunes a Viernes: 9am - 5pm (EST)",
      sendMessage: "Envíanos un Mensaje",
      successMessage: "¡Gracias! Tu mensaje ha sido enviado con éxito.",
      errorMessage: "Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde.",
      form: {
        email: "Tu Correo Electrónico",
        subject: "Asunto",
        message: "Mensaje",
        send: "Enviar Mensaje",
        sending: "Enviando..."
      },
      location: "Nuestra Ubicación",
      address: "C. Navío, 3, 11540 Sanlúcar de Barrameda, Cádiz, España"
    }
  },
  de: {
    contact: {
      title: "Kontaktieren Sie Uns",
      getInTouch: "Nehmen Sie Kontakt Auf",
      description: "Haben Sie Fragen oder Feedback? Wir würden gerne von Ihnen hören. Nutzen Sie das untenstehende Formular oder kontaktieren Sie uns direkt.",
      email: "E-Mail",
      linkedin: "LinkedIn",
      officeHours: "Geschäftszeiten",
      hours: "Montag bis Freitag: 9-17 Uhr (EST)",
      sendMessage: "Senden Sie uns eine Nachricht",
      successMessage: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.",
      errorMessage: "Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      form: {
        email: "Ihre E-Mail",
        subject: "Betreff",
        message: "Nachricht",
        send: "Nachricht Senden",
        sending: "Wird gesendet..."
      },
      location: "Unser Standort",
      address: "C. Navío, 3, 11540 Sanlúcar de Barrameda, Cádiz, Spanien"
    }
  },
  fr: {
    contact: {
      title: "Contactez-nous",
      getInTouch: "Entrez en contact",
      description: "Vous avez des questions? Nous sommes à votre écoute. Remplissez le formulaire ou contactez-nous directement par email.",
      email: "Email",
      linkedin: "LinkedIn",
      officeHours: "Heures de bureau",
      hours: "Lundi - Vendredi: 9h00 - 17h00",
      sendMessage: "Envoyez-nous un message",
      successMessage: "Votre message a été envoyé avec succès!",
      errorMessage: "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
      form: {
        email: "Votre email",
        subject: "Sujet",
        message: "Message",
        send: "Envoyer",
        sending: "Envoi en cours..."
      },
      location: "Notre Emplacement",
      address: "C. Navío, 3, 11540 Sanlúcar de Barrameda, Cadix, Espagne"
    }
  },
  hi: {
    contact: {
      title: "हमसे संपर्क करें",
      getInTouch: "संपर्क में रहें",
      description: "प्रश्न या प्रतिक्रिया है? हमें आपसे सुनना अच्छा लगेगा। नीचे दिए गए फॉर्म का उपयोग करें या सीधे संपर्क करें।",
      email: "ईमेल",
      linkedin: "लिंक्डइन",
      officeHours: "कार्यालय समय",
      hours: "सोमवार से शुक्रवार: सुबह 9 बजे से शाम 5 बजे (ईएसटी)",
      sendMessage: "हमें एक संदेश भेजें",
      successMessage: "धन्यवाद! आपका संदेश सफलतापूर्वक भेज दिया गया है।",
      errorMessage: "आपका संदेश भेजने में एक त्रुटि हुई। कृपया बाद में पुन प्रयास करें।",
      form: {
        email: "आपका ईमेल",
        subject: "विषय",
        message: "संदेश",
        send: "संदेश भेजें",
        sending: "भेज रहा है...",
      },
      location: "हमारा स्थान",
      address: "C. Navío, 3, 11540 Sanlúcar de Barrameda, Cádiz, स्पेन"
    }
  }
};
